import { useState, useEffect } from "react";
import { getAssessmentSectionById } from "../../utils/assessments";

const useFetchAssessmentSection = (
  assessmentId,
  sectionId,
  questionSidebar
) => {
  const [sections, setSections] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (assessmentId && sectionId && questionSidebar) {
      const fetchData = async () => {
        try {
          const assessmentSection = await getAssessmentSectionById(
            assessmentId,
            sectionId
          );
          setSections(assessmentSection);
        } catch (err) {
          setError(err.message);
        }
      };

      fetchData();
    }
  }, [assessmentId, sectionId, questionSidebar]);

  return { sections, error };
};

export default useFetchAssessmentSection;
